import daisyui from "daisyui"
import scrollbar from 'tailwind-scrollbar';
const colors = {
    'blue-custom-1': '#e3ecfd',
    'blue-custom-2': '#3561fe',
    'blue-custom-3': '#d9edf6',
    'blue-custom-4': '#2f7491',
    'blue-custom-5': '#e3ecfd',
    'blue-custom-6': '#4eb7f1',
    'blue-custom-7': '#daecf6',
    'blue-custom-8': '#494db9',
    'blue-custom-9': '#e1e1fd',
    'blue-custom-10': '#ebedfc',
    'blue-custom-11': '#dde4ee',
    'blue-custom-12': '#245d85',
    'gray-custom-1': '#747474',
    'gray-custom-2': '#d2d7db',
    'gray-custom-3': '#333333',
    'gray-custom-4': '#666666',
    'gray-custom-5': '#dbdbdb',
    'gray-custom-6': '#f6f7f9',
    'gray-custom-7': '#fdfffd',
    'gray-custom-8': '#66656a',
    'gray-custom-9': '#4a4a4a',
    'green-custom-1': '#1ba407',
    'green-custom-2': '#eafde7',
    'green-custom-3': '#19a308',
    'green-custom-4': '#b2ca36',
    'green-custom-5': '#dcede1',
    'green-custom-6': '#1ba405',
    'red-custom-1': '#fee2e3',
    'red-custom-2': '#cc0000',
    'red-custom-3': '#ffe2e2',
    'red-custom-4': '#cc0001',
    'red-custom-5': '#f3dce1',
    'red-custom-6': '#f57676',
    'yellow-custom-1': '#ffcc00',
    'yellow-custom-2': '#fef7da',
    'yellow-custom-3': '#f9ffd7',
    'yellow-custom-4': '#ffd400',
    'purple-custom-1': '#f9e7ff',
    'purple-custom-2': '#b440e9',
    'purple-custom-3': '#bf58ec',
    'purple-custom-4': '#b541ea',
    'purple-custom-5': '#fae8fe',
    'purple-custom-6': '#f9e7ff',
    'orange-custom-1': '#fbeacc',
    'orange-custom-2': '#fe6b0a',
    'orange-custom-3': '#ff6600',
    'orange-custom-4': '#fcebcd',
    'orange-custom-5': '#ffeacb',
    'orange-custom-6': '#ff6801',
    'orange-custom-7': '#f3ece1',
    'orange-custom-8': '#ff9900',
    'orange-custom-9': '#fb3f10',
};
export default {
    content: [
        "./resources/**/*.blade.php",
        "./resources/**/*.js",
        "./resources/**/*.vue",
    ],
     safelist: [
    'progress-primary',
    'progress-success',
    'progress-warning',
    'progress-info',
    'progress-error',
    'progress-secondary',
  ],
    theme: {
        screens: {
            'sm': '640px',
            'md': '768px',
            'lg': '1024px',
            'xl': '1280px',
            '2xl': '1536px',
          },
        extend: {
            fontFamily: {
                iransans: ["IRANSans", "sans-serif"],
            },
            colors: colors,
            width:{
                '4.5': '1.125rem'
            },
            height:{
                '4.5': '1.125rem'
            },
            animation: {
                border: 'border 4s ease infinite',
              },
            keyframes: {
                border: {
                  '0%, 100%': { backgroundPosition: '0% 50%' },
                  '50%': { backgroundPosition: '100% 50%' },
                },
              },
        },
    },
    plugins: [daisyui, scrollbar({ nocompatible: true })],
    daisyui: {
        darkTheme: 'mytheme',
        themes: [
            {
                mytheme: {
                    success: colors["green-custom-1"],
                    primary: colors["blue-custom-2"],
                    warning: colors["yellow-custom-1"],
                    error: colors["red-custom-2"],
                    info: colors["blue-custom-6"],
                    secondary: "#f6d860",
                    accent: "#37cdbe",
                    neutral: "#3d4451",
                    "base-100": "#ffffff",
                    "base-200": "#f2f5fc",
                },
            },
            'dark'
        ],
        rtl: true
    }
}